import * as React from 'react';
import './Home.css';
import { ClassNames } from '../../_helpers/ClassNames';
import { HomeDto } from 'src/@types/api';
import Image from '../Image/Image';
import { MouseWheelHandler } from '../../MouseWheelHandler';
import * as Intro from '../../Assets/intro.svg';
import * as IntroMobile from './intro_mobile.svg';
import * as Hammer from 'hammerjs';

export type HomeProps = HomeDto;

type state = {
    startPageState: "full" | "half" | "out";
    currentSlide: number;

};
export class HomeWrapped extends React.Component<HomeProps, state> {
    private images: Array<React.RefObject<HTMLDivElement>>;
    private imagesContainer: React.RefObject<HTMLDivElement>;
    private container: React.RefObject<HTMLDivElement>;
    private MouseWheelHandler: MouseWheelHandler;

    private hammer: HammerManager;

    constructor(props: HomeProps) {
        super(props);

        this.images = this.props.HomeSlides.map(slide => React.createRef());
        this.imagesContainer = React.createRef();
        this.container = React.createRef();
        this._SplashPageAnimation = this._SplashPageAnimation.bind(this);
        this._handleKeydown = this._handleKeydown.bind(this);
        const { hash } = window.location;
        const isFull = hash.replace("#", "") !== "home";

        this._Next = this._Next.bind(this);
        this._Previous = this._Previous.bind(this);

        this.state = {
            startPageState: isFull ? 'full' : 'half',
            currentSlide: 0
        };
    }

    componentDidMount() {
        const { startPageState } = this.state;

        if (startPageState === "full") {
            setTimeout(() => this._Next(), 2800);
        }

        window.addEventListener('keydown', this._handleKeydown);
        if (!this.MouseWheelHandler) {
            this.MouseWheelHandler = new MouseWheelHandler(this._Previous.bind(this), this._Next.bind(this));
        }
        this.MouseWheelHandler.listen();
        const { container: { current } } = this;
        if (!this.hammer && current) {
            this.hammer = new Hammer(current);
            this.hammer.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });
            this.hammer.on("swipe", this._OnSwipe.bind(this));
        }
    }
    componentDidUpdate() {
        const { startPageState, currentSlide } = this.state;
        let y = 0;

        if (startPageState === "half") {
            this.imagesContainer.current!.style.transform = `translateY(${y}px)`;
            return;
        }

        if (startPageState === "out") {
            for (let i = 0; i < currentSlide; i++) {
                y += this.images[i].current!.clientHeight;
            }

            y += this.images[currentSlide].current!.clientHeight / 2;
        }
        y += 30; // padding for 1st image
        this.imagesContainer.current!.style.transform = `translateY(${-y}px)`;
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this._handleKeydown);
        if (this.MouseWheelHandler) {
            this.MouseWheelHandler.unlisten();
        }
        if (this.hammer) {
            this.hammer.destroy();
        }
    }

    render() {
        const { StartpageImage, HomeSlides, Color } = this.props;
        const { startPageState, currentSlide } = this.state;

        return (
            <React.Fragment>
                <div
                    className={ClassNames('home', '', 'desktop')}
                    ref={this.container}
                >
                    <div
                        className={ClassNames("home", "splash", startPageState)}
                        style={{ backgroundColor: Color }}
                        onClick={() => this._SplashPageAnimation()}
                    >
                        <div className={ClassNames("home", "splash-img-wrap")} >

                            <img
                                className={ClassNames("home", "splash-img")}
                                src={Intro}
                            />
                        </div>
                    </div>
                    <div
                        className={ClassNames("home", "content", "text")}
                        style={{ backgroundColor: Color }}
                    >
                        {HomeSlides.map((slide, i) => (
                            <div
                                key={i}
                                className={
                                    ClassNames("home", "slide-text",
                                        startPageState === "out" && currentSlide === i ? "active" : "")}
                            >
                                <h4 className={ClassNames("home", "slide-title")}>
                                    {slide.Title}
                                </h4>
                                <div
                                    className={ClassNames("home", "text")}
                                    dangerouslySetInnerHTML={{ __html: slide.Text }}
                                />
                            </div>
                        ))}
                    </div>
                    <div
                        className={ClassNames("home", "content", "images")}
                    >
                        <div
                            className={ClassNames("home", "content-inner")}
                            ref={this.imagesContainer}
                        >
                            {StartpageImage &&
                                <div className={ClassNames("home", "start-page-image")}>
                                    <Image
                                        pictureRef={StartpageImage}
                                        className={ClassNames("home", "image", "start-page")}
                                        sizes={"50vw"}
                                    />
                                </div>
                            }
                            {HomeSlides.map((slide, i) => (
                                <div
                                    key={i}
                                    className={
                                        ClassNames(
                                            "home",
                                            "slide-image",
                                            slide.SlideImage.Width / slide.SlideImage.Height <= 1 ?
                                                "portrait" : "landscape")
                                    }
                                    ref={this.images[i]}
                                >
                                    <Image
                                        pictureRef={slide.SlideImage}
                                        className={ClassNames("home", "image")}
                                        sizes={"50vw"}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div
                    className={ClassNames('home', '', 'mobile')}
                >
                    <div
                        className={ClassNames("home", "splash-mobile")}
                        style={{ backgroundColor: Color }}
                    >
                        <div className={ClassNames("home", "splash-text-mobile", 'animate')}>
                            <img
                                className={ClassNames("home", "splash-img")}
                                src={IntroMobile}
                            />
                        </div>
                    </div>
                    <figure className={ClassNames("home", "splash-image-outer")}>
                        <Image
                            pictureRef={StartpageImage}
                            sizes={"100vw"}
                            className={ClassNames("home", "splash-image-mobile")}
                        />
                    </figure>
                    {HomeSlides.map((slide, i) =>
                        <div
                            key={i}
                            className={ClassNames("home", "slide-mobile", i % 2 === 0 ? "" : "grey-background")}
                        >
                            <h4 className={ClassNames("home", "slide-title-mobile")}>
                                {slide.Title}
                            </h4>
                            <div
                                className={ClassNames("home", "slide-text-mobile")}
                                dangerouslySetInnerHTML={{ __html: slide.Text }}
                            />
                            <figure className={ClassNames("home", "slide-image-mobile")}>
                                <Image
                                    className={ClassNames("home", "image-mobile")}
                                    pictureRef={slide.SlideImage}
                                    sizes={"100vw"}
                                />
                            </figure>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
    private _OnSwipe(ev: HammerInput) {
        if (ev.direction === Hammer.DIRECTION_UP) {
            this._Next();
        } else {
            this._Previous();
        }
    }
    private _SplashPageAnimation() {
        if (this.state.startPageState === "full") {
            this.setState(() => ({ startPageState: "half" }))
        } else {
            this.setState(() => ({
                startPageState: "out",
                currentSlide: 0
            }))
        }
    }

    private _Go(i: number) {
        this.setState(() => ({
            currentSlide: i
        }));
    }

    private _Next() {
        const { startPageState, currentSlide } = this.state;

        if (startPageState === "full") {
            this.setState(() => ({ startPageState: "half" }))
            return;
        }

        if (startPageState === "half") {
            this.setState(() => ({ startPageState: "out" }))
            return;
        }

        if (currentSlide < (this.props.HomeSlides.length - 1)) {
            this._Go(currentSlide + 1);
        }
    }

    private _Previous() {
        const { startPageState, currentSlide } = this.state;

        if (startPageState === "half") {
            return;
        }

        if (startPageState === "out" && currentSlide === 0) {
            this.setState(() => ({ startPageState: "half" }))
            return;
        }

        if (currentSlide >= 1) {
            this._Go(currentSlide - 1);
        }
    }

    private _handleKeydown(e: KeyboardEvent) {
        switch (e.keyCode) {
            case 37: // left
                break;
            case 38: // up
                this._Previous();
                break;
            case 39: // right
                break;
            case 40: // down
                this._Next();
                break;
            default:
                break;
        }
    }

};

export const Home = HomeWrapped;
export default Home;


// WEBPACK FOOTER //
// ./src/Components/Home/Home.tsx